import { render } from "./somaNotas.vue?vue&type=template&id=7d4094e0"
import script from "./somaNotas.vue?vue&type=script&lang=js"
export * from "./somaNotas.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__